import { inject, Injectable } from '@angular/core';
import { map, Observable, of } from 'rxjs';
import { WorkerPermissionsPort } from '../../domain/ports/worker-permissions.port';
import { Permission } from '../../domain/models/permission.model';
import { SERVICE_STATE_SERVICE } from '@features/service/domain/tokens/service-state.token';
import { ServiceStatePort } from '@features/service/domain/port/service-state.port';
import { PermissionStore } from '../../application/stores/permission.store';

@Injectable({ providedIn: 'root' })
export class WorkerPermissionsAdapter implements WorkerPermissionsPort {
  private readonly serviceStateService = inject<ServiceStatePort>(SERVICE_STATE_SERVICE);
  private readonly permissionStore = inject(PermissionStore);

  getCurrentWorkerPermissionIds(): Observable<string[]> {
    const currentWorker = this.serviceStateService.getCurrentWorker();

    if (!currentWorker) {
      return of([]);
    }

    return of(currentWorker.permissions || []);
  }

  getCurrentWorkerPermissions(): Observable<Permission[]> {
    return this.getCurrentWorkerPermissionIds().pipe(
      map(permissionIds => {
        return permissionIds
          .map(id => this.permissionStore.getPermissionById(id))
          .filter((permission): permission is Permission => permission !== undefined);
      })
    );
  }
}